import { render } from "./ModalPayfix.vue?vue&type=template&id=6f7de6b7&scoped=true"
import script from "./ModalPayfix.vue?vue&type=script&lang=js"
export * from "./ModalPayfix.vue?vue&type=script&lang=js"

import "./ModalPayfix.vue?vue&type=style&index=0&id=6f7de6b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7de6b7"]])

export default __exports__